import { WebProtocol } from 'src/common/constants/web';

export const getPageProtocol = (window: Window): string =>
  window && window.location && window.location.protocol
    ? window.location.protocol
    : WebProtocol.HTTP;
